module.exports = __webpack_public_path__ + "static/media/poster1.8fbdce13.jpg";